/* ZIZA: signup popup (snippets/ziza-signup-popup.liquid).
   Post naar join.zizaclub.com, zelfde pipeline als ziza-newsletter.js.
   Verwijderen = deze file + de snippet + de render-regel in layout/theme.liquid. */
(function () {
  var STORAGE_KEY = 'ziza-popup';
  var SESSION_KEY = 'ziza-popup-shown';
  var DISMISS_DAYS = 30;

  var overlay = document.getElementById('ZizaSignupPopup');
  if (!overlay) return;
  if (window.Shopify && window.Shopify.designMode) return;

  /* Einddatum-guard voor gecachte pagina's; de snippet rendert na dit
     moment sowieso niet meer (popup_ends_at in de liquid). */
  var endsEpoch = parseInt(overlay.dataset.ends, 10);
  if (endsEpoch && Date.now() / 1000 >= endsEpoch) return;

  function state() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; }
    catch (e) { return {}; }
  }
  function save(data) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch (e) {}
  }
  /* Max 1x per sessie: zodra de popup opent zetten we een sessionStorage-vlag,
     zodat hij bij verder browsen (of terugkomen op home/product) wegblijft. */
  function shownThisSession() {
    try { return sessionStorage.getItem(SESSION_KEY) === '1'; } catch (e) { return false; }
  }
  /* Free-tote sheet al getoond deze sessie: geen nieuwsbrief-popup (v1.2). */
  function toteShownThisSession() {
    try { return sessionStorage.getItem('ziza-tote-shown') === '1'; } catch (e) { return false; }
  }
  function suppressed() {
    if (shownThisSession() || toteShownThisSession()) return true;
    var s = state();
    if (s.subscribed) return true;
    if (s.dismissedAt && Date.now() - s.dismissedAt < DISMISS_DAYS * 864e5) return true;
    return false;
  }

  if (suppressed()) return;

  var modal = overlay.querySelector('.ziza-popup-modal');
  var form = overlay.querySelector('.ziza-popup-form');
  var input = overlay.querySelector('.ziza-popup-input');
  var button = overlay.querySelector('.ziza-popup-button');
  var errorEl = overlay.querySelector('.ziza-popup-error');
  var opened = false;
  var lastFocus = null;

  function open() {
    if (opened || suppressed()) return;
    opened = true;
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
    lastFocus = document.activeElement;
    overlay.hidden = false;
    overlay.classList.add('is-open');
    document.addEventListener('keydown', onKeydown);
    window.setTimeout(function () { input && input.focus(); }, 50);
  }

  function close(remember) {
    overlay.classList.remove('is-open');
    overlay.hidden = true;
    document.removeEventListener('keydown', onKeydown);
    if (remember) {
      var s = state();
      s.dismissedAt = Date.now();
      save(s);
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKeydown(event) {
    if (event.key === 'Escape') close(true);
    if (event.key === 'Tab') {
      var focusables = modal.querySelectorAll('button, input, [tabindex]:not([tabindex="-1"])');
      var visible = Array.prototype.filter.call(focusables, function (el) {
        return el.offsetParent !== null;
      });
      if (!visible.length) return;
      var first = visible[0];
      var last = visible[visible.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  overlay.querySelector('.ziza-popup-close').addEventListener('click', function () { close(true); });
  overlay.querySelector('.ziza-popup-dismiss').addEventListener('click', function () { close(true); });
  overlay.addEventListener('click', function (event) {
    if (event.target === overlay) close(true);
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    var email = input.value.trim();
    errorEl.style.display = 'none';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      errorEl.textContent = overlay.dataset.msgInvalid || 'Please enter a valid email.';
      errorEl.style.display = 'block';
      input.focus();
      return;
    }
    button.disabled = true;
    fetch('https://join.zizaclub.com/subscribe', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ email: email, source: 'Website popup' })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('subscribe failed');
        var s = state();
        s.subscribed = true;
        save(s);
        modal.classList.add('is-done');
      })
      .catch(function () {
        errorEl.textContent = overlay.dataset.msgError || 'Something went wrong. Please try again.';
        errorEl.style.display = 'block';
        button.disabled = false;
      });
  });

  /* v1.2: pas na 15 s of na 50% scrollen, wat het eerst komt. */
  var delay = parseInt(overlay.dataset.delay, 10) || 15000;
  var timer = window.setTimeout(trigger, delay);

  function onScroll() {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    if (max > 0 && window.scrollY / max >= 0.5) trigger();
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  function trigger() {
    window.clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
    open();
  }
})();
